import { useMutation, useQueryClient } from "react-query";

import { WorkspaceDocumentConvertData } from "@interfaces/company/workspace";
import { workspaceQueryKeys } from "./queryKeys";
import { workspaceService } from "@services/workspace-service";

export const useConvertWorkspaceDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceDocumentConvertData) =>
      workspaceService.convertDocument(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
      },
    }
  );
};
